"use strict";

import angular from "angular";

import template from "./comments-csat.component.html";
import "./comments-csat.component.scss";

import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";

import moment from "moment";
import { Report } from "../../../gateway/Report/Report";
import toastCustomTemplate from "../nu-toast-custom/toast-custom.component.html";

class CommentsCsatComponent {
    constructor(toast) {
        this.Report = new Report();

        this.toast = toast;

        //{ score: 0, comment: "", userId: "", opinion: [""], date: new Date() }
        this.emojiItems = {
            crying: "far fa-sad-cry",
            sad: "far fa-frown",
            meh: "far fa-meh",
            smile: "far fa-smile",
            happy: "far fa-laugh-beam"
        };

        this.chipsDescription = [
            "Gostei muito da entrega",
            "Fácil compreensão",
            "Encontrei um erro",
            "Estou com dúvidas",
            "Quero marcar uma reunião"
        ];
        this.allowInputs = false;
        this.user = new UserDataAdapter().user();
    }

    $onInit() {
        if (!this.feedback) {
            this.allowInputs = true;
            this.feedback = {
                score: 0,
                comment: "",
                userId: "",
                opinion: []
            };
        }
    }

    showToastGenerated() {
        this.toast.show("", "bottom right", {
            hideDelay: 1000,
            controllerAs: "ctrl",
            locals: {
                toastMessage: "Comentário enviado com sucesso!",
                action: [
                    {
                        style: "md-icon-button desnu-button-icon desnu-button-small",
                        icon: "dsn-icon-button fas fa-times",
                        click: () => {
                            this.toast.hide();
                        }
                    }
                ]
            },
            template: toastCustomTemplate
        });
    }

    /**
     * @public
     * Checa qual chip deve estar ativado ou não com ng-class
     */
    checkChipActive = (chip) =>
        this.feedback.opinion.length && this.feedback.opinion.includes(chip);

    /**
     * @public
     * Método responsável em armazenar/retirar qual chip está selecionado/sem seleção
     */
    onSelectChip = (chip) => {
        if (this.feedback.opinion.includes(chip)) {
            const chipIndex = this.feedback.opinion.indexOf(chip);

            return this.feedback.opinion.splice(chipIndex, 1);
        }

        this.feedback.opinion.push(chip);
    };

    /**
     * @public
     * Método responsável pela seleção do emoji
     */
    onSelectEmoji = (score) => {
        if (this.feedback.score === score) return (this.feedback.score = 0);
        this.feedback.score = score;
    };

    async submit() {
        this.loading = true;
        this.feedback.date = new Date();
        this.feedback.userId = this.user._id;

        try {
            this.afterSend();
            this.showToastGenerated();
            await this.Report.updateOne(this.reportId, {
                feedback: this.feedback
            });
        } catch (ex) {
        } finally {
            this.loading = false;
        }
    }
}

export { CommentsCsatComponent };

CommentsCsatComponent.$inject = ["toast"];

const name = "commentsCsatComponent";
const def = {
    bindings: {
        reportId: "<",
        feedback: "<",
        afterSend: "&"
    },
    controller: CommentsCsatComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
